import React from "react";

interface State { error: Error | null; info: React.ErrorInfo | null }

export class ErrorBoundary extends React.Component<{ children: React.ReactNode }, State> {
  state: State = { error: null, info: null };

  static getDerivedStateFromError(error: Error): Partial<State> {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("ErrorBoundary caught:", error.name, error.message);
    console.error("Stack:", error.stack);
    console.error("Component stack:", info.componentStack);
    this.setState({ info });
  }

  reset = () => this.setState({ error: null, info: null });

  render() {
    if (!this.state.error) return this.props.children;
    const { error, info } = this.state;
    return (
      <div className="p-4 min-h-full flex flex-col items-stretch gap-3">
        <div className="text-center">
          <div className="text-3xl">😵</div>
          <h1 className="text-xl font-semibold mt-2">Щось пішло не так</h1>
          <p className="text-tg-hint text-sm mt-1">{error.message}</p>
        </div>

        <details className="card text-xs" open>
          <summary className="cursor-pointer font-medium mb-2">Технічні деталі</summary>
          <div className="font-mono whitespace-pre-wrap break-words overflow-auto max-h-60 text-[10px] text-tg-hint">
            <div className="text-red-700 mb-1">{error.name}: {error.message}</div>
            {error.stack && <div className="mb-2">{error.stack}</div>}
            {info?.componentStack && <div>Component stack:{info.componentStack}</div>}
          </div>
        </details>

        <div className="flex gap-2">
          <button className="btn-secondary flex-1" onClick={this.reset}>
            Спробувати ще
          </button>
          <button className="btn-primary flex-1" onClick={() => location.reload()}>
            Перезавантажити
          </button>
        </div>
      </div>
    );
  }
}
